import { useMutation, UseMutationOptions } from 'react-query';
import { shiftClaimService } from 'ogp/services';
import { OGPShiftClaimExportPayload } from 'ogp/services/shift-claim-service.types';

type ShiftClaimExportMutationOptions = UseMutationOptions<
  Blob,
  unknown,
  OGPShiftClaimExportPayload
>;

export const useGetShiftClaimExport = (options?: ShiftClaimExportMutationOptions) => {
  const mutationFn = async (getShiftClaimsData: OGPShiftClaimExportPayload) =>
    await shiftClaimService.createShiftClaimsExport(getShiftClaimsData);

  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: ShiftClaimExportMutationOptions = {
    onSuccess: (data, ...restArg) => {
      onSuccess && onSuccess(data, ...restArg);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};
